import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../common/Navbar";
import { TbDeviceMobileMessage, TbFileCheck } from "react-icons/tb";
import { GrDocumentPdf } from "react-icons/gr";
import { FaRegFilePdf } from "react-icons/fa";
import { FaArrowRightLong, FaArrowDown } from "react-icons/fa6";
import { CiSquareCheck } from "react-icons/ci";
import ContactUs from "../common/ContactUs";
import Footer from "../common/Footer";

const HowItWorksPage = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    document.title = "How it works?";
    // Check screen size for arrow switch
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      className="bg-light text-dark"
      style={{ fontFamily: "Arial, sans-serif" }}
    >
      {/* Header */}
      <Navbar />

      {/* Hero Section */}
      <section className="container bg-light" style={{ padding: "100px 0px" }}>
        <div className="row">
          <div className="col-md-2"></div>
          {/* <div className="col-md-6 pt-100"> */}
          <div className="col-md-6">
            <h1 className="display-3" id="main-font">
              TEXT2COURT
            </h1>
            <h1 className="display-5" id="main-font">
              Turn your text messages into court-ready PDFs
            </h1>
            <Link
              className="btn btn-outline-dark mt-3 px-5 py-2"
              type="submit"
              to="/register"
              id="main-font"
              aria-label="Try Text2Court now"
            >
              Try It Now
            </Link>
          </div>
          <div className="col-md-4" style={{ paddingTop: "100px" }}>
            <TbDeviceMobileMessage
              className="p-0"
              size={200}
              color="black"
              style={{ transform: "scaleX(-1)" }}
            />
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="py-5 bg-white">
        <div className="container py-4">
          <h1 className="display-4" id="main-font">
            How It Works
          </h1>
          <div className="row d-flex align-items-center justify-content-center">
            <div className="col-12 col-sm-6 col-md-2 text-center mb-4">
              <div className="d-flex justify-content-center">
                <TbDeviceMobileMessage size={60} className="mb-2" />
              </div>
              <p>Upload Your SMS Conversations</p>
            </div>

            <div className="col-12 col-sm-1 text-center mb-4">
              {isMobile ? (
                <FaArrowDown size={35} />
              ) : (
                <FaArrowRightLong size={35} />
              )}
            </div>

            <div className="col-12 col-sm-6 col-md-2 text-center mb-4">
              <div className="d-flex justify-content-center">
                <FaRegFilePdf className="p-0" size={60} />
              </div>
              <p>AI converts them to admissible exhibits</p>
            </div>

            <div className="col-12 col-sm-1 text-center mb-4">
              {isMobile ? (
                <FaArrowDown size={35} />
              ) : (
                <FaArrowRightLong size={35} />
              )}
            </div>

            <div className="col-12 col-sm-6 col-md-2 text-center mb-4">
              <div className="d-flex justify-content-center">
                <TbFileCheck className="p-0" size={60} />
              </div>
              <p>Certified according to Rule 902</p>
            </div>

            <div className="col-12 col-sm-1 text-center mb-4">
              {isMobile ? (
                <FaArrowDown size={35} />
              ) : (
                <FaArrowRightLong size={35} />
              )}
            </div>

            <div className="col-12 col-sm-6 col-md-2 text-center mb-4">
              <div className="d-flex justify-content-center">
                <GrDocumentPdf className="p-0" size={60} />
              </div>
              <p>Organized into a court-ready PDF</p>
            </div>
          </div>
        </div>
        <style jsx>{`
          @media (max-width: 768px) {
            .row {
              flex-direction: column;
              align-items: center;
            }
          }
        `}</style>
      </section>

      {/* Unmatched Accuracy Section */}
      <section className="py-5 light-bg-section">
        <div className="container py-4">
          <h1 className="display-4" id="main-font">
            Unmatched Accuracy
          </h1>
          <h1 className="display-5" id="main-font">
            100% success rate for texts admitted in US courts
          </h1>
          <p className="mt-4 mb-0 display-6" id="main-font">
            Is Text2Court right for your case?
          </p>
          <p className="my-2">
            <CiSquareCheck className="" size={25} /> Communications with
            opposing parties
          </p>
          <p className="my-2">
            <CiSquareCheck className="" size={25} /> Proof of agreements or
            harassment
          </p>
          <p className="my-2">
            <CiSquareCheck className="" size={25} /> Confirmation of dates or
            alibis
          </p>
        </div>
      </section>

      <ContactUs />
      <Footer />
    </div>
  );
};

export default HowItWorksPage;

// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import Navbar from "../common/Navbar";
// import { TbDeviceMobileMessage, TbFileCheck } from "react-icons/tb";
// import { GrDocumentPdf } from "react-icons/gr";
// import { FaRegFilePdf } from "react-icons/fa";
// import { FaArrowRightLong } from "react-icons/fa6";
// import { CiSquareCheck } from "react-icons/ci";
// import ContactUs from "../common/ContactUs";
// import Footer from "../common/Footer";

// const HowItWorksPage = () => {
//   useEffect(() => {
//     document.title = "How it works?";
//   }, []);
//   return (
//     <div className="bg-light text-dark" style={{ fontFamily: 'Arial, sans-serif' }}>
//       {/* Header */}
//      <Navbar/>

//       {/* Hero Section */}
// <section className="container bg-light" style={{padding:'100px 0px'}}>
//   <div className="row">
//     <div className="col-md-2"></div>
//     {/* <div className="col-md-6 pt-100"> */}
//      <div className="col-md-6">
//       <h1 className="display-3" id="main-font">TEXT2COURT</h1>
//       <h1 className="display-5" id="main-font">Turn your text messages into court-ready PDFs</h1>
//       <Link
//         className="btn btn-outline-dark mt-3 px-5 py-2"
//         type="submit"
//         to="/register"
//         id="main-font"
//         aria-label="Try Text2Court now"
//       >
//         Try It Now
//       </Link>
//     </div>

//     <div className="col-md-4" style={{ paddingTop: "100px" }}>
//       <TbDeviceMobileMessage
//         className="p-0"
//         size={200}
//         color="black"
//         style={{ transform: "scaleX(-1)" }}
//       />
//     </div>
//   </div>
// </section>

//         <section className="py-5 bg-white">
//           <div className="container py-4">
//             <h1 className="display-4" id="main-font">How It Works</h1>
//             <div className="row">
//                 <div className="col-md-1 mt-5"></div>
//                 <div className="col-md-2 text-center">
//                     <div className="d-flex justify-content-center">
//                         <TbDeviceMobileMessage size={80} />
//                     </div>
//                     <p className="text-center">Upload Your SMS Conversations</p>
//                 </div>

//                 <div className="col-md-1 mt-5"><FaArrowRightLong size={35}/></div>
//                 <div className="col-md-2">
//                     <div className="d-flex justify-content-center">
//                         <FaRegFilePdf className="p-0" size={80} />
//                     </div>
//                     <p className="text-center">AI converts them to admissible exhibits</p>
//                 </div>
//                 <div className="col-md-1 mt-5"><FaArrowRightLong size={35}/></div>
//                 <div className="col-md-2">
//                     <div className="d-flex justify-content-center">
//                         <TbFileCheck className="p-0" size={80} />
//                     </div>
//                     <p className="text-center">Certified according to Rule 902</p>
//                 </div>
//                 <div className="col-md-1 mt-5"><FaArrowRightLong size={35}/></div>
//                 <div className="col-md-2">
//                     <div className="d-flex justify-content-center">
//                         <GrDocumentPdf className="p-0" size={80} />
//                     </div>
//                     <p className="text-center">Organized into a court-ready PDF</p>
//                 </div>
//             </div>
//           </div>
//         </section>

// <section className="py-5 light-bg-section">
//   <div className="container py-4">
//     <h1 className="display-4" id="main-font">Unmatched Accuracy</h1>
//     <h1 className="display-5" id="main-font">100% success rate for texts admitted in US courts</h1>
//     <p className="mt-4 mb-0 display-6" id="main-font">Is Text2Court right for your case?</p>
//     <p className="my-2"><CiSquareCheck className="" size={25} /> Communications with opposing parties</p>
//     <p className="my-2"><CiSquareCheck className="" size={25} /> Proof of agreements or harassment</p>
//     <p className="my-2"><CiSquareCheck className="" size={25} /> Confirmation of dates or alibis</p>
//   </div>
// </section>

//      <ContactUs/>
//      <Footer/>
//     </div>
//   );
// };

// export default HowItWorksPage;
